export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetSchool(context) {
      context.commit("updateSchool", false)
    },
  },
  mutations: {
    updateSchool(state, data) {
      return state.data = data
    }
  }
}